export default {
  single_flat: {
    calculations: [],
  },
  flats: {
    results: [],
    count: 0,
  },
  flat_statuses: [{
      id: 1,
      title: {
        uz: '',
        ru: 'Свободно',
        en: 'available',
      },
      color: 'success',
    },
    {
      id: 2,
      title: {
        uz: '',
        ru: 'Забронировано',
        en: 'booked',
      },
      color: 'warning',
    },
    {
      id: 3,
      title: {
        uz: 'Sotilgan',
        ru: 'Продано',
        en: 'Sold',
      },
      color: 'secondary',
    },
    {
      id: 4,
      title: {
        uz: 'Band qilingan',
        ru: 'Занято',
        en: 'occupied',
      },
      color: 'primary',
    },
  ],
  flat_plannings: [],
  flat_types: [{
      title: {
        uz: 'Turar-joy',
        ru: 'Жилое',
      },
      value: true,
    },
    {
      title: {
        uz: 'Noturar-joy',
        ru: 'Нежилое',
      },
      value: false,
    },
  ],
  characteristic: [],
  flatPercentages: []
}